import React from "react";
import { withNamespaces } from "react-i18next";

import {
  Label,
  Container,
  Col,
  Form,
  Card,
  CardHeader,
  CardBody,
  Button,
  Row,
} from "reactstrap";
import { Input } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import { message } from "antd";

import LogoLogin from "./../../../resources/logo_login.png";
import { Services } from "../../../repositories/clients/Services";

import Authentication from "../../../services/Authentication.js";
import SessionStorage from "../../../services/SessionStorage";
import { SetNewListGroups } from "../../../state/actions/Header";
import { isMobile, getBrowserInfo } from "../../utils/userAgent";

import loginOBL from "./../../../resources/OBL-backgr.webp";
import styled from "styled-components";

import "./styles.scss";

const auth = new Authentication();
const dt = new Date();

const BackgroundContainer = styled.div`
  flex: 1 1 0%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-image: url(${loginOBL});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  padding-left: 5%;

  @media (max-width: 768px) {
    display: none;
  }
`;
/*=============================================
=            Login Component                  =
=============================================*/

function Login(props) {
  const [redirectlogin, setRedirectlogin] = React.useState({
    login: {
      email: localStorage.getItem("email") ? localStorage.getItem("email") : "",
      valid: false,
      password: localStorage.getItem("password")
        ? localStorage.getItem("password")
        : "",
      check: localStorage.getItem("email") ? true : false,
    },
  });
  let [password, setPassword] = React.useState(false);
  const [recoverPassword, setrecoverPassword] = React.useState("");
  const [response] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  /*=============================================
  =            Handle Login Function            =
  =============================================*/
  function change(event) {
    document.getElementById("email_sin").setAttribute("hidden", "hidden");
    document.getElementById("pass_sin").setAttribute("hidden", "hidden");
    document.getElementById("error_user").setAttribute("hidden", "hidden");

    if (event.target.name === "email") {
      let value = event.target.value;
      const emailRegex = new RegExp(/^\S+@\S+\.\S+$/);
      if (emailRegex.test(value)) {
        redirectlogin.login.valid = true;
        document.getElementById("input_email").className = "input100";
        document.getElementById("email_alert").setAttribute("hidden", "hidden");
      } else {
        redirectlogin.login.valid = false;
        // document.getElementById('input_email').className = 'invalidInput';

        document.getElementById("email_alert").removeAttribute("hidden");
      }
      redirectlogin.login[event.target.name] = value;
      setRedirectlogin({ redirectlogin, ...redirectlogin });
    } else {
      let value = event.target.value;
      redirectlogin.login[event.target.name] = value;
      setRedirectlogin({ redirectlogin, ...redirectlogin });
    }
  }

  function changeCorreo(event) {
    document.getElementById("correo_alert").removeAttribute("hidden");
    document
      .getElementById("correo_alert_base")
      .setAttribute("hidden", "hidden");
    document.getElementById("correo_sin").setAttribute("hidden", "hidden");
    let value = event.target.value;
    const emailRegex = new RegExp(/^\S+@\S+\.\S+$/);
    if (emailRegex.test(value)) {
      document.getElementById("input_correo").className = "input100";
      document.getElementById("correo_alert").setAttribute("hidden", "hidden");
      document.getElementById("correo_aler_button").removeAttribute("hidden");
    } else {
      document.getElementById("input_correo").className = "invalidInput";
      document.getElementById("correo_alert").removeAttribute("hidden");
      document
        .getElementById("correo_aler_button")
        .setAttribute("hidden", "hidden");
    }
    setrecoverPassword(value);
  }

  function handleSubmit(e) {
    e.preventDefault();
    handleLoginId();
  }
  async function handleLoginId() {
    try {
      setLoading(true);
      if (!redirectlogin.login.email) {
        document.getElementById("email_sin").removeAttribute("hidden");
        setLoading(false);
      } else if (!redirectlogin.login.password) {
        document.getElementById("pass_sin").removeAttribute("hidden");
        setLoading(false);
      } else {
        document.getElementById("email_sin").setAttribute("hidden", "hidden");
        document.getElementById("pass_sin").setAttribute("hidden", "hidden");
        let data = {
          email: redirectlogin.login.email,
          password: redirectlogin.login.password,
        };

        console.log("url", `${Services.ADMIN.path}oauth/setAuthentication`);

        const response = await axios.post(
          `${Services.ADMIN.path}oauth/setAuthentication`,
          data,
        );

        let token = response.data.token;
        let redirectUserData = response.data.data;
        if (redirectlogin.login.check) {
          localStorage.setItem("email", redirectlogin.login.email);
          localStorage.setItem("password", redirectlogin.login.password);
        }
        let id = response.data.data[0].UserId;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        const groups = await axios.get(
          `${Services.ADMIN.path}admin/customerForId/v2/${id}?zona=${timezone}&lang=${response.data.data[0].Code}`,
        );

        await props.SetNewListGroups({
          group_list: groups.data.resp,
          clients: groups.data.clients,
          nit: groups.data.NIT,
          notify: groups.data.Notify,
          lang: "ES",
          // lang: response.data.data[0].Code
        });
        const session = new SessionStorage();

        session.addItem("group_list", JSON.stringify(groups.data.resp));
        session.addItem("clients", JSON.stringify(groups.data.clients));
        session.addItem("nit", JSON.stringify(groups.data.NIT));
        session.addItem("notify", JSON.stringify(groups.data.Notify));
        // session.addItem("lang", response.data.data[0].Code);
        session.addItem("lang", "ES");
        auth.setAuthentication(
          token,
          redirectUserData,
          groups.data.resp,
          redirectlogin.login.email,
        );

        await props.history.push("/dashboard");
        setLoading(false);

        const createOffsetValue = (date) => {
          let sign = date.getTimezoneOffset() > 0 ? "-" : "+";
          let offset = Math.abs(date.getTimezoneOffset());
          let hours = Math.floor(offset / 60);
          let minutes = ((offset % 60) / 60) * 10;
          return sign + hours + "." + minutes;
        };
        let Origin = await isMobile();
        let getBrowserInfoAgente = await getBrowserInfo();

        let userAudit = {
          UsuarioId: id,
          SessionId: token,
          StartConnection: new Date(),
          timezone: createOffsetValue(new Date()),
          Origin: Origin ? "Mobile" : "Desktop",
          Browser: getBrowserInfoAgente.name,
        };
        axios.post(`${Services.AUDIT.path}user-logs/login`, userAudit);
      }
    } catch (error) {
      setLoading(false);
      document.getElementById("error_user").removeAttribute("hidden");
      console.error("handleLoginId", error);
    }
  }

  function handleAccount() {
    if (!recoverPassword) {
      document.getElementById("correo_sin").removeAttribute("hidden");
    } else {
      document.getElementById("correo_sin").setAttribute("hidden", "hidden");
      let data = {
        correo: recoverPassword,
      };

      axios
        .post(`${Services.ADMIN.path}admin/recover`, data)
        .then(() => {
          // document.getElementById("correo_exitoso").removeAttribute("hidden");
          sendMessage(props.t("mail_send_successfully"), "success");
          setPassword(false);
          setrecoverPassword("");
        })
        .catch((error) => {
          if (error.response) {
            // setresponse(error.response.data.message);
            sendMessage(props.t(error.response.data.message), "error");
            // document
            //   .getElementById("correo_alert_base")
            //   .removeAttribute("hidden");
          }
        });
    }
  }

  function sendMessage(text, type) {
    var messageClass = "";
    if (type === "error") {
      messageClass =
        "general-custom-ant-message error-blue-ant-message  ant-centered";
    } else if (type === "success") {
      messageClass =
        "general-custom-ant-message success-custom-ant-message ant-centered";
    } else if (type === "info") {
      messageClass = "info-custom-ant-message";
    }
    message.open({
      content: text,
      className: messageClass,
    });
  }
  // function sendMessage(text, type) {
  //   Swal.fire({
  //     icon: type,
  //     confirmButtonColor: "#2b3b57",
  //     confirmButtonText: "Ok",
  //     html: `<div class="text-center">
  //     ${text}
  //     </div>`,
  //   });
  // }
  React.useEffect(() => {
    // i18n.changeLanguage(navLang.split("-")[0] == "es" ? "ES" : "EN")
  }, []);

  function funtionRegresa() {
    setPassword(!password);
    setrecoverPassword("");

    document.getElementById("input_correo").className = "input100";
    document.getElementById("correo_sin").setAttribute("hidden", "hidden");
    document.getElementById("correo_alert").setAttribute("hidden", "hidden");
    document
      .getElementById("correo_alert_base")
      .setAttribute("hidden", "hidden");
    document
      .getElementById("correo_aler_button")
      .setAttribute("hidden", "hidden");
    document.getElementById("correo_exitoso").setAttribute("hidden", "hidden");
  }

  if (redirectlogin.login.check) {
    localStorage.setItem("email", redirectlogin.login.email);
    localStorage.setItem("password", redirectlogin.login.password);
  } else {
    localStorage.removeItem("email", "email");
    localStorage.removeItem("password", "password");
  }
  // function changeLanguage(value) {
  //   setLang(value);
  //   i18n.changeLanguage(value)
  // }
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <BackgroundContainer>
        <div
          style={{
            height: "40%", // Ocupa el 40% del alto del div principal
            display: "flex",
            alignItems: "center",
            textAlign: "left",
            fontSize: "clamp(1.5rem, 2.5vw, 2.5rem)", // Tamaño responsivo
            lineHeight: "1.3",
            maxWidth: "600px", // Limita el ancho para mejor lectura
          }}
        >
          <span className="custom-font-span">
            ADVANCED{" "}
            <strong>
              DIGITAL <br /> EXPERIENCE ON <br /> END-TO-END <br />
            </strong>{" "}
            VISIBILITY
          </span>
        </div>
      </BackgroundContainer>

      <div className="login-page">
        <Container>
          {!password ? (
            <Form onSubmit={handleSubmit}>
              {/* <div className="wrap-login100 p-t-0 p-b-0"> */}
              <Card className="loginContainer">
                {/* <div className="col-12">
                    <center>
                      <img
                        src={nameRol4ll}
                        alt="App Logo"
                        width={'240px'}
                        height={'120px'}
                      />
                    </center>
                  </div> */}
                <CardHeader>
                  <div style={{ width: "100%" }} className="logo-container">
                    <img src={LogoLogin} alt="now-logo" />
                  </div>
                </CardHeader>

                <CardBody style={{ marginTop: "-6em", marginBottom: "2em" }}>
                  {/* <div
                      style={{ marginLeft: '-1px' }}
                      className="wrap-input100 row validate-input m-b-12 "
                      data-validate="Usuario es Requerido"
                    > */}
                  <br />
                  <Col
                    xs={11}
                    style={{ textAlign: "left" }}
                    className="ml-auto mr-auto"
                  >
                    {/* <label className="labelPrimary">{props.t("email")}</label> */}
                    <Input
                      style={{ borderRadius: "0px" }}
                      // icon="icon-final-19"
                      placeholder={props.t("email")}
                      // iconPosition="left"
                      fluid
                      id="input_email"
                      type="text"
                      value={redirectlogin.login.email}
                      name="email"
                      onChange={change}
                    />
                  </Col>
                  <Col
                    xs={11}
                    style={{ textAlign: "left" }}
                    className="ml-auto mr-auto"
                  >
                    <div
                      className="_alert"
                      id="email_alert"
                      hidden
                      style={{
                        textAlign: "start",
                        fontSize: "12px",
                        color: "red",
                      }}
                    >
                      {props.t("valid_email")}
                    </div>
                  </Col>
                  <br />
                  <Col
                    xs={11}
                    style={{ textAlign: "left" }}
                    className="mr-auto ml-auto"
                  >
                    {/* <label className="labelPrimary">{props.t("password")}</label> */}
                    <Input
                      // icon="demo-icon icon-lock"
                      placeholder={props.t("pass")}
                      // iconPosition="left"
                      fluid
                      type="password"
                      value={redirectlogin.login.password}
                      name="password"
                      onChange={change}
                    />
                  </Col>

                  {/* </div> */}

                  <Col xs={11} className="ml-auto mr-auto">
                    {/* <div
                      style={{ marginLeft: '-1px' }}
                      className="row validate-input m-b-12"
                      data-validate="Contraseña es Requerida"
                    >
                      <span className="focus-input100"></span>
                    </div> */}
                    <div
                      style={{
                        textAlign: "start",
                        fontSize: "12px",
                        color: "red",
                      }}
                      className="_alert"
                      id="email_sin"
                      hidden
                    >
                      {props.t("user_pass_invalid")}
                    </div>
                    <div
                      style={{
                        textAlign: "start",
                        fontSize: "12px",
                        color: "red",
                      }}
                      className="_alert"
                      id="pass_sin"
                      hidden
                    >
                      {props.t("pass_required")}
                    </div>
                    <div
                      style={{
                        textAlign: "start",
                        fontSize: "12px",
                        color: "red",
                      }}
                      className="_alert"
                      id="error_user"
                      hidden
                    >
                      {props.t("user_pass_invalid")}
                    </div>
                  </Col>
                  {/* </div> */}
                  <br />
                  {/* <div className="col-12">
                      <div
                        style={{ fontSize: "15px", color: "#fff" }}
                        className="col-12"
                      >
                        <Label id="chkTest1">
                       

                          <CheckboxM
                            style={{ marginRight: "-8px", marginTop: "-3px" }}
                            onChange={() => {
                              redirectlogin.login.check =
                                !redirectlogin.login.check;
                              setRedirectlogin({
                                redirectlogin,
                                ...redirectlogin,
                              });
                            }}
                            checked={redirectlogin.login.check}
                          />

                          <spam style={{ fontSize: "14px" }}>
                            {props.t("remember_pass")}

                          </spam>
                        </Label>
                      </div>
                    </div>
                    <Label
                      className="forgot_pass"
                      onClick={() => {
                        setPassword(!password);
                      }}
                    >
                      <b>{props.t("forgot_pass")}</b>
                    </Label> */}

                  <Col xs={11} className="ml-auto mr-auto">
                    <Button
                      type="submit"
                      className="btn-login"
                      // color='danger'
                      // style={{ cursor: loading ? "not-allowed" : "pointer" }}
                      disabled={loading}
                    >
                      {loading ? props.t("getting_access") : props.t("login")}
                    </Button>
                  </Col>
                  <Col xs={10} className="ml-auto mr-auto">
                    <Label
                      className="forgot_pass"
                      onClick={() => {
                        setPassword(!password);
                      }}
                    >
                      <b>{props.t("forgot_pass")}</b>
                    </Label>
                  </Col>
                  <Col xs={11} className="ml-auto mr-auto">
                    <div className="login_info">
                      <spam>{props.t("login_info_1")}</spam>
                    </div>
                  </Col>
                  <Col xs={11} className="ml-auto mr-auto">
                    <div className="login_desc">
                      <spam>{props.t("login_info_2")}</spam>
                    </div>
                  </Col>

                  <br />
                  <Col xs={11} md={11} lg={11} className="ml-auto mr-auto">
                    <div className="_copy_rigth">
                      Copyright © {dt.getFullYear()}{" "}
                      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                      <a>Onboard Logistics</a> {props.t("reserved_rights")}
                    </div>
                    <div className="_terminos">
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={props.t("terms_and_conditions_url")}
                      >
                        {props.t("private_policy")}
                        <spam>|</spam> {props.t("terms_and_conditions")}
                      </a>
                    </div>
                  </Col>
                </CardBody>
              </Card>
              {/* </div> */}
            </Form>
          ) : (
            // <Col className="ml-auto mr-auto">

            // </Col>
            <Form>
              <Card className="loginContainer">
                <CardHeader>
                  <div className="logo-container">
                    <img src={LogoLogin} alt="now-logo" />
                  </div>
                  {/* <div className="logo-container">
                      <span className={"tex_1"}>{props.t("your_shipments")}</span>{" "}
                      <span className={"tex_2"}>{props.t("always_close")}</span>
                    </div> */}
                </CardHeader>
                <CardBody>
                  <Col
                    style={{ marginTop: "-2em", marginBottom: "2em" }}
                    className="ml-auto mr-auto"
                  >
                    <div className="col-12">
                      <label style={{ fontSize: "24px" }}>
                        {props.t("recover_pass")}
                      </label>
                    </div>
                    <div className="col-12">
                      <label style={{ fontSize: "12px" }}>
                        {props.t("insert_mail")}
                      </label>
                    </div>
                    <br />
                    {/* <div style={{ height: 10 }} /> */}
                    <div className="col-12" style={{ textAlign: "center" }}>
                      {/* <div
                        className="wrap-input100 validate-input m-b-12 "
                        data-validate="Correo es requerio"
                      > */}
                      <Input
                        icon="fas fa-lock"
                        placeholder={props.t("email")}
                        iconPosition="left"
                        fluid
                        // className="input100"
                        id="input_correo"
                        type="text"
                        value={recoverPassword}
                        name="correo"
                        onChange={changeCorreo}
                      />
                      {/* <span className="focus-input100"></span>
                      </div> */}
                      <div
                        style={{
                          // padding: '3px',
                          // marginTop: '-14px',
                          fontSize: "12px",
                        }}
                        className="_alert"
                        id="correo_alert"
                        hidden
                      >
                        {props.t("valid_email")}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                        }}
                        className="_alert"
                        id="correo_alert_base"
                        hidden
                      >
                        {response}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                        }}
                        className="_alert"
                        id="correo_sin"
                        hidden
                      >
                        {props.t("mail_required")}
                      </div>
                      <div
                        style={{
                          fontSize: "12px",
                        }}
                        className="_alert"
                        id="error_correo"
                        hidden
                      >
                        {props.t("mail_is_not_registered")}
                      </div>
                      <div
                        style={{
                          fontSize: "14px",
                        }}
                        className="_alert"
                        id="correo_exitoso"
                        hidden
                      >
                        {props.t("mail_send_successfully")}
                      </div>
                    </div>
                    <br />

                    <Row>
                      <Col xs={5} className="ml-auto mr-auto">
                        <Button
                          style={{
                            fontWeight: "bold",
                            background: "#FF0000",
                          }}
                          block
                          color="secondary"
                          onClick={funtionRegresa}
                        >
                          {props.t("back")}
                        </Button>
                      </Col>
                      <Col xs={5} className="ml-auto mr-auto">
                        <Button
                          style={{ fontWeight: "bold" }}
                          block
                          color="primary"
                          id="correo_aler_button"
                          onClick={handleAccount}
                        >
                          {props.t("send")}
                        </Button>
                      </Col>
                    </Row>
                  </Col>
                </CardBody>
              </Card>
            </Form>
          )}
        </Container>
      </div>
    </div>
  );
}

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  SetNewListGroups: (new_group_list) =>
    dispatch(SetNewListGroups(new_group_list)),
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(Login)),
);
